module.exports = __webpack_public_path__ + "img/getGift.2b6393b4.png";